export default __webpack_public_path__ + "static/media/translate.9445cc38.svg";